import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { areEqual } from 'Utils/equalityChecks';

import { DeleteExternalAtmosphericLogModal } from 'Components/RocketDry';

import { deleteExternalAtmosphericLog } from 'Containers/RocketDry/actions';

import { useRocketDryFunctions } from 'Context/RocketDry';

const DeleteExternalAtmosphericLogModalContainer = () => {
  const dispatch = useDispatch();

  const { isDeleteAtmosphericLogModalOpen, setIsDeleteAtmosphericLogModalOpen, selectedAtmosphericLog }: any =
    useRocketDryFunctions();

  const closeModal = useCallback(() => {
    setIsDeleteAtmosphericLogModalOpen(false);
  }, []);

  const onDeleteButtonClick = useCallback(() => {
    dispatch(deleteExternalAtmosphericLog(selectedAtmosphericLog.id, closeModal));
  }, [selectedAtmosphericLog]);

  return (
    <DeleteExternalAtmosphericLogModal
      isOpen={isDeleteAtmosphericLogModalOpen}
      atmosphericLog={selectedAtmosphericLog}
      closeModal={closeModal}
      onDeleteButtonClick={onDeleteButtonClick}
    />
  );
};

const DeleteExternalAtmosphericLogModalContainerMemo = memo(DeleteExternalAtmosphericLogModalContainer, areEqual);

export { DeleteExternalAtmosphericLogModalContainerMemo as DeleteExternalAtmosphericLogModal };
